export const HUBSPOT_MEETING_KMUTO_URL = 'https://meetings.hubspot.com/kmuto';
export const HUBSPOT_MEETING_IMUTO_URL = 'https://meetings.hubspot.com/imuto';
